export default __webpack_public_path__ + "static/media/in-transit.872ef95e.png";